import React, {useState, useEffect} from "react";
import Column from "@amzn/meridian/column";
import Button from "@amzn/meridian/button";
import Row from "@amzn/meridian/row";
import DateRangePicker from "@amzn/meridian/date-range-picker";
import Text from "@amzn/meridian/text";
import Input from "@amzn/meridian/input";
import { FormattedMessage, injectIntl } from "react-intl";
import {useDeviceLayout} from "../../../commons/context/DeviceLayoutContext";

const ContainerSearchTab = ({ intl }) => {
    let localTodayInMillis = new Date().getTime() - (new Date().getTimezoneOffset() * 60 * 1000);
    let today = new Date(localTodayInMillis).toISOString().substr(0, 10);
    var initialInputValue = "";
    var initialStartDate = today;
    var initialEndDate = today;

    const [dateValue, setDateValue] = useState([initialStartDate, initialEndDate]);
    const [inputValue, setInputValue] = useState(initialInputValue);
    const [errorInput, setErrorInput] = useState(false);
    const [errorStartDateInput, setErrorStartDateInput] = useState(false);
    const [errorEndDateInput, setErrorEndDateInput] = useState(false);
    const {isMobile} = useDeviceLayout();

    const onClickSearch = () => {
        let [startDate, endDate] = dateValue ? dateValue : [null, null];
        if (!startDate) {
            setErrorStartDateInput(true);
            return;
        }
        if (!endDate) {
            setErrorEndDateInput(true);
            return;
        }
        let request = {
            "type": "CONTAINER",
            "startDate": new Date(startDate).getTime() + (new Date().getTimezoneOffset() * 60 * 1000),
            "endDate": new Date(endDate).getTime() + (new Date().getTimezoneOffset() * 60 * 1000) + (60 * 60 * 24 * 1000)
        }
        let trimmedInputValue = inputValue ? inputValue.trim() : null;
        if (trimmedInputValue) {
            let url = "#/detailPage/" + trimmedInputValue.replace(/\//g, "") + "/" + JSON.stringify(request); 
            window.open(url, '_self');
        } else {
            setErrorInput(true);
        }
    }

    useEffect(() => {
        let [startDate, endDate] = dateValue ? dateValue : [null, null];
        if (startDate) {
            setErrorStartDateInput(false);
        }
        if (endDate) {
            setErrorEndDateInput(false);
        }
    }, [dateValue]);


    useEffect(() => {
        if (inputValue) {
            setErrorInput(false);
        }
    }, [inputValue]);

    return (
        <Column>
            <Row spacingInset="medium none">
                <Input value={inputValue} onChange={setInputValue} error={errorInput} label={intl.formatMessage({id: "search.container.searchTab_containerId"})} rows={1} width = "300px"/>
            </Row>
            <Row spacingInset="none none">
                <Text type="h300"><FormattedMessage id="search.container.searchTab_activityDate" defaultMessage="Activity Date"/></Text>
            </Row>
            <Row spacingInset="none none">
                <DateRangePicker allowSameStartAndEnd = {true} startError={errorStartDateInput} endError={errorEndDateInput} value={dateValue} onChange={setDateValue} startLabel={intl.formatMessage({id: "search.container.searchTab_startDate"})} endLabel={intl.formatMessage({id: "search.container.searchTab_endDate"})} monthsInView={1}/>
            </Row>
            <Row spacingInset="medium none" alignmentHorizontal={isMobile ? "center" : "start"}>
                <Button onClick={onClickSearch}><FormattedMessage id="search.container.searchTab_search" defaultMessage="Search"/></Button>
            </Row>
        </Column>
    )
}

export default injectIntl(ContainerSearchTab);



// WEBPACK FOOTER //
// ./src/components/detailPages/searchTabs/ContainerSearchTab.js